import React from 'react';
import Modal from 'shared/components/misc/modal';
import WordExportForm from 'shared/components/show/wordExportForm';
import UIRegions from 'shared/constants/UIRegions';

const title = (
  <span>
    Word Export
    <a
      className="learn-more-link"
      target="_blank"
      href="https://shoflo.tv/word-export/"
    >
      Learn More
    </a>
  </span>
);

/**
 * Word Export Form Modal
 *
 */
export default React.createClass({
  displayName: 'ShowWordExportFormModal',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    return (
      <Modal
        className="modal-word-export"
        headerClassName="modal-generic-header"
        name={UIRegions.WordExportForm}
        title={title}
      >
        <WordExportForm {...this.context.router.state.params} />
      </Modal>
    );
  },
});
